import BarnService from '../../services/BarnService';
import * as types from './types';
import { dispatchNetworkRequest } from '../networkDispatcher';

export const searchTaskNames = (barnId, taskTypeId, search, page = 0, pageSize = 25, sort = '') => (dispatch) => {
  const promise = BarnService.searchTaskNameSuggestions(barnId, page, pageSize, sort, taskTypeId, search);
  dispatchNetworkRequest({
    dispatch,
    requestType: types.SEARCH_TASK_NAMES_REQUESTED,
    successType: types.SEARCH_TASK_NAMES_SUCCESS,
    errorType: types.SEARCH_TASK_NAMES_ERROR,
    promise,
    defaultErrorMessage: 'There was a problem trying to search for suggested task names',
    responseName: 'suggestions',
  });
  return promise;
};
